import React from 'react';
import {Container, Grid} from '@material-ui/core'
import {Link , BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import Header from '../Header/Header';
import Footer from '../Footer/Footer'
import Profile from '../Profile/Profile'
import Portfolio from '../Portfolio/Portfolio';
import Resume from '../Resume/Resume';
import './Home.css'
import About from '../About/About';
import Contact from '../Contact/Contact';
const Home = () => {
    return (
<>
<Container  className={"top_60"} >
    <Grid container  spacing={3} >
                <Grid Container xs={12} item lg={3} md={4} sm={12}>
                   <Profile />
                </Grid>
                <Grid xs>
                    <Router>
                    <Header />
                    <div className="main-content">
                    <Switch >

                            <Route path="/portfolio">
                                <Portfolio />
                            </Route>

                            <Route exact path="/">
                                <Resume />
                            </Route>

                            <Route  path="/about">
                                <About />
                            </Route>
                            <Route  path="/contact">
                                <Contact />
                            </Route>
                        </Switch>
                    </div>
                      
                    </Router>
                           
                           <Footer />
                         
                </Grid>
    </Grid>
</Container>
</>
    );
};

export default Home;

